"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterestsKeys = exports.InterestItems = void 0;
exports.validateInterest = validateInterest;
exports.getInterestByDisplayName = getInterestByDisplayName;
exports.getInterestItems = getInterestItems;
const interestsItems = {
    travel: {
        icon: "uil-plane-departure",
        interest: "travel",
        displayName: "Viagens e turismo",
    },
    "pop-culture": {
        icon: "uil-tv-retro",
        interest: "pop-culture",
        displayName: "Cultura pop (filmes, música, séries)",
    },
    sports: {
        icon: "uil-football",
        interest: "sports",
        displayName: "Esportes",
    },
    technology: {
        icon: "uil-processor",
        interest: "technology",
        displayName: "Tecnologia e inovação",
    },
    gastronomy: {
        icon: "uil-utensils",
        interest: "gastronomy",
        displayName: "Gastronomia e culinária internacional",
    },
    fashion: {
        icon: "uil-plane-departure",
        interest: "fashion",
        displayName: "Moda e tendências",
    },
    wellbeing: {
        icon: "uil-smile",
        interest: "wellbeing",
        displayName: "Saúde e bem-estar",
    },
    influencers: {
        icon: "uil-star",
        interest: "influencers",
        displayName: "Mídias sociais e influenciadores digitais",
    },
    music: {
        icon: "uil-music",
        interest: "music",
        displayName: "Músicas e instrumentos musicais",
    },
    history: {
        icon: "uil-hourglass",
        interest: "history",
        displayName: "História e civilizações antigas",
    },
    entrepeneurship: {
        icon: "uil-bag",
        interest: "entrepeneurship",
        displayName: "Empreendedorismo e negócios",
    },
    sustentability: {
        icon: "uil-trees",
        interest: "sustentability",
        displayName: "Sustentabilidade e meio ambiente",
    },
    arts: {
        icon: "uil-image",
        interest: "arts",
        displayName: "Arte e pintura",
    },
    photography: {
        icon: "uil-camera",
        interest: "photography",
        displayName: "Fotografia e edição de imagens",
    },
    literature: {
        icon: "uil-book-open",
        interest: "literature",
        displayName: "Literatura e escritores famosos",
    },
    games: {
        icon: "uil-desktop-alt",
        interest: "games",
        displayName: "Jogos e videogames",
    },
    science: {
        icon: "uil-atom",
        interest: "science",
        displayName: "Ciência e descobertas recentes",
    },
    "outdoor-actitivies": {
        icon: "uil-mountains-sun",
        interest: "outdoor-actitivies",
        displayName: "Atividades ao ar livre",
    },
    design: {
        icon: "uil-paint-tool",
        interest: "design",
        displayName: "Design de interiores e decoração",
    },
    philoshophy: {
        icon: "uil-comments-alt",
        interest: "philoshophy",
        displayName: "Filosofia e pensadores renomados",
    },
};
exports.InterestItems = Object.values(interestsItems);
exports.InterestsKeys = Object.keys(interestsItems);
function validateInterest(interest) {
    const findedInterest = exports.InterestItems.find((i) => i.interest === interest);
    if (findedInterest) {
        return findedInterest.interest;
    }
    return null;
}
function getInterestByDisplayName(displayName) {
    for (const key of exports.InterestsKeys) {
        if (interestsItems[key].displayName === displayName) {
            return key;
        }
    }
    return null;
}
function getInterestItems(maybeInterests) {
    return maybeInterests
        .map((maybeInterest) => {
        const interestItem = exports.InterestItems.find((item) => item.interest === maybeInterest);
        if (!interestItem) {
            return null;
        }
        return interestItem;
    })
        .filter((i) => i !== null);
}
//# sourceMappingURL=interests.utils.js.map